import Container from "../components/Container.jsx";

const cards = [
  {
    title: "Stamp Duty Calculator",
    href: "#/stamp-duty",
    desc: "Calculate UK stamp duty for residential or investment purchases.",
    // optional: replace with an icon/image
    emoji: "📑",
  },
  {
    title: "Investment to Retirement",
    href: "#/retirement",
    desc: "Project how today’s contributions can translate into retirement income.",
    emoji: "📈",
  },
    {
    title: "Mortgage Calculator",
    href: "#/mortgage",
    desc: "Calculate how much you can borrow based upon your current financial situation",
    emoji: "🧮",
  },
];

export default function Resources() {
  return (
    <main className="py-10">
      <Container>
        <h1 className="text-4xl font-bold text-[#003366]">Resources</h1>
        <p className="mt-3 max-w-2xl text-slate-700">
          Tools and calculators to help you plan your next investment.
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {cards.map((c) => (
            <a
              key={c.title}
              href={c.href}
              className="group block rounded-2xl border border-slate-200 p-6 hover:shadow-md transition"
            >
              <div className="flex items-start gap-4">
                <div className="text-3xl" aria-hidden>{c.emoji}</div>
                <div>
                  <h3 className="text-lg font-semibold text-[#003366] group-hover:opacity-80">
                    {c.title}
                  </h3>
                  <p className="mt-1 text-slate-700">{c.desc}</p>
                  <span className="mt-3 inline-block text-sm font-semibold text-[#003366]">
                    Open →
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </Container>
    </main>
  );
}
